module.exports = __webpack_public_path__ + "assets/1792649897182/img/floating-window-traning-icon.6086c17c.png";